import { businessConfig } from '../../../config/businessConfig';

export default function Location() {
  const hasLocation = Boolean(businessConfig.address && businessConfig.googleMapsUrl);

  return (
    <section className="section location" id="ubicacion">
      <div className="container location__card">
        <div>
          <p className="eyebrow">Encuéntranos</p>
          <h2 className="section-title">Tu momento comienza aquí.</h2>
          {hasLocation ? (
            <><p>{businessConfig.address}{businessConfig.district ? `, ${businessConfig.district}` : ''}</p><p>Estacionamiento disponible.</p></>
          ) : (
            <p>La ubicación exacta se compartirá y confirmará directamente al coordinar tu atención.</p>
          )}
          {hasLocation ? <a className="button button--gold" href={businessConfig.googleMapsUrl} target="_blank" rel="noreferrer">Cómo llegar</a> : null}
        </div>
        <div className="location__map">
          {businessConfig.googleMapsEmbedUrl ? (
            <iframe title="Mapa de Mujer Virtuosa" src={businessConfig.googleMapsEmbedUrl} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
          ) : (
            <div className="media-pending"><span>Ubicación</span><small>pendiente de configuración</small></div>
          )}
        </div>
      </div>
    </section>
  );
}
